import {create} from 'zustand'
import {devtools, persist} from 'zustand/middleware'
import * as React from "react";

type Store = {
  exerciseInfo: {
    title: string,
    target: number,
    kcal: number,
    unitType: string,
    infoText: string,
    navi: () => void,
  },
  mealInfo: {
    title: string,
    target: number,
    kcal: number,
    unitType: string,
    infoText: string,
    navi: () => void,
  },
  stepInfo: {
    title: string,
    target: number,
    kcal: number,
    unitType: string,
    infoText: string,
    navi: () => void,
  },
  moistureInfo: {
    title: string,
    target: number,
    kcal: number,
    unitType: string,
    infoText: string,
    navi: () => void,
  },
  selectedFoodList: []
  setSelectedFoodList: (by: []) => void
  selectedExerciseList: []
  setSelectedExerciseList: (by: []) => void
}

const useStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        exerciseInfo: {title: '', target: 0, kcal: 0, unitType: '', infoText: '', navi: () => {}},
        setExerciseInfo: (name: any, value: any) => set((state: any) => {
          state.exerciseInfo[name] = value;
          return {}
        }),
        mealInfo: {title: '', target: 0, kcal: 0, unitType: '', infoText: '', navi: () => {}},
        setMealInfo: (name: any, value: any) => set((state: any) => {
          state.mealInfo[name] = value;
          return {}
        }),
        stepInfo: {title: '', target: 0, kcal: 0, unitType: '', infoText: '', navi: () => {}},
        setStepInfo: (name: any, value: any) => set((state: any) => {
          state.stepInfo[name] = value;
          return {}
        }),
        moistureInfo: {title: '', target: 0, kcal: 0, unitType: '', infoText: '', navi: () => {}},
        setMoistureInfo: (name: any, value: any) => set((state: any) => {
          state.moistureInfo[name] = value;
          return {}
        }),
        selectedFoodList: [],
        setSelectedFoodList: (by: []) => set((state) => ({ selectedFoodList: by })),
        selectedExerciseList: [],
        setSelectedExerciseList: (by: []) => set((state) => ({ selectedExerciseList: by })),
      }),
      { name: 'historyStore' },
    ),
  ),
)

export default useStore;